import axios from '../../plugins/axiosPlugin'

export default {
  state: {
    allEvents: [],
    allEventsLoading: false,

    selectedEvent: null,
    selectedEventLoading: false,

    logs: [],
    logsLoading: false,

    gewerke: [],
    gewerkeLoading: false,

    calendarView: true

  },
  mutations: {
    setAllEvents(state, allEvents) {
      state.allEvents = allEvents
    },
    setAllEventsLoading(state, allEventsLoading) {
      state.allEventsLoading = allEventsLoading
    },
    setSelectedEvent(state, selectedEvent) {
      state.selectedEvent = selectedEvent
    },
    setSelectedEventLoading(state, selectedEventLoading) {
      state.selectedEventLoading = selectedEventLoading
    },
    setSelectedLogs(state, logs) {
      state.logs = logs
    },
    setLogsLoading(state, logsLoading) {
      state.logsLoading = logsLoading
    },
    setCalendarView(state, value) {
      state.calendarView = value
    },
    setGewerke(state, gewerke) {
      state.gewerke = gewerke
    },
    setGewerkeLoading(state, gewerkeLoading) {
      state.gewerkeLoading = gewerkeLoading
    }
  },
  actions: {
    getAllEvents(context) {
      context.commit('setAllEvents', [])
      context.commit('setAllEventsLoading', true)
      let url = 'lagerverwaltung/event'
      axios
        .get(url)
        .then((response) => context.commit('setAllEvents', response.data.data))
        .catch((e) => console.error("Daten konnten nicht abgefrufen werden!"))
        .finally(() => context.commit('setAllEventsLoading', false))
    },
    getEventDetails(context, eventId) {
      context.commit('setSelectedEventLoading', true)

      let url = 'lagerverwaltung/event/' + eventId

      axios
        .get(url)
        .then((response) => {
            context.commit('setSelectedEvent', response.data.data)
        })
        .catch((e) => console.log("Error: "))
        .finally(() => context.commit('setSelectedEventLoading', false))
    },
    getAllGewerke(context) {
      context.commit('setGewerkeLoading', true)
      const url = 'lagerverwaltung/gewerk'
      axios
        .get(url)
        .then((response) => context.commit('setGewerke', response.data.data))
        .catch((e) => console.log("Error: "))
        .finally(() => context.commit('setGewerkeLoading', false))
    },
    getLogDetails(context, eventId) {
      let url = 'lagerverwaltung/event/' + eventId + '?details=true'
      context.commit('setLogsLoading', true)
      axios
        .get(url)
        .then((repsonse) => {
          context.commit('setSelectedLogs', repsonse.data.data)
        })
        .catch((e) => console.log("Error: "))
        .finally(() => context.commit('setLogsLoading', false))
    },
    async createEventPromise(context, event) {
      let url = 'lagerverwaltung/event'

      return axios.put(url, event)
    },
    async editEventPromise(context, event) {
      let url = 'lagerverwaltung/event/' + event.ID

      return axios.post(url, event)
    },
    async deleteEventPromise(context, eventID) {
      const url = 'lagerverwaltung/event/' + eventID
      return axios.delete(url)
    }
  }
}
